'use client';
import styles from './drawer.module.css';
import {
	faArrowRightToBracket,
	faBars,
	faCircleInfo,
	faComments,
	faEnvelopeOpen,
	faHouse,
	faPenToSquare,
	faUser,
	faWrench,
} from '@awesome.me/kit-012d1b9af0/icons/classic/regular';
import { CloseButton, Drawer, Portal } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import useModal from '@/components/modal/use-modal';
import NotificationModal from '@/components/modal/notification-modal/notificaton-modal';
import { signOut, useSession } from 'next-auth/react';

const MenuDrawer = () => {
	const { data: session } = useSession();

	const [open, setOpen] = useState(false);
	const { isOpen, onClose, onOpen } = useModal();

	const pathname = usePathname();

	const isActive = (path: string) => pathname === path;

	async function tabHandler(notification = false, logout = false) {
		setOpen(false);

		if (notification) onOpen('notification-modal');

		if (logout) await signOut();
	}

	return (
		<>
			<Drawer.Root
				open={open}
				onOpenChange={(e) => setOpen(e.open)}
				placement={'start'}
			>
				<Drawer.Trigger asChild>
					<button
						className={styles['icon-container']}
						aria-label='Open navigation menu'
					>
						<FontAwesomeIcon icon={faBars} color='#fff' size='xl' />
					</button>
				</Drawer.Trigger>
				<Portal>
					<Drawer.Backdrop />
					<Drawer.Positioner marginTop={'16'}>
						<Drawer.Content outline={'none'}>
							<Drawer.Body>
								<div className={styles.tabs}>
									{/* home */}
									<Link href={'/'} onClick={() => tabHandler()}>
										<div
											className={styles.tab}
											style={{
												backgroundColor: `${isActive('/') ? 'lightblue' : ''}`,
											}}
										>
											<div style={{ width: '2rem' }}>
												<FontAwesomeIcon
													icon={faHouse}
													size='xl'
													className={styles.icon}
												/>
											</div>
											<p>Home Page</p>
										</div>
									</Link>

									{/* about */}
									<Link href={'/about'} onClick={() => tabHandler()}>
										<div
											className={styles.tab}
											style={{
												backgroundColor: `${
													isActive('/about') ? 'lightblue' : ''
												}`,
											}}
										>
											<div style={{ width: '2rem' }}>
												<FontAwesomeIcon
													icon={faCircleInfo}
													size='xl'
													className={styles.icon}
												/>
											</div>
											<p>About</p>
										</div>
									</Link>

									{/* account */}
									{session && (
										<>
											{/* sci profile */}
											<Link href={'/sciprofile'} onClick={() => tabHandler()}>
												<div
													className={styles.tab}
													style={{
														backgroundColor: `${
															isActive('/sciprofile') ? 'lightblue' : ''
														}`,
													}}
												>
													<div style={{ width: '2rem' }}>
														<FontAwesomeIcon
															icon={faUser}
															size='xl'
															className={styles.icon}
														/>
													</div>
													<p>Your SCI Profile</p>
												</div>
											</Link>

											{/* notfication setting */}
											<div onClick={() => tabHandler(true)}>
												<div className={styles.tab}>
													<div style={{ width: '2rem' }}>
														<FontAwesomeIcon
															icon={faEnvelopeOpen}
															size='xl'
															className={styles.icon}
														/>
													</div>
													<p>Notification Settings</p>
												</div>
											</div>

											{/* account setting */}
											<Link href={'/account'} onClick={() => tabHandler()}>
												<div
													className={styles.tab}
													style={{
														backgroundColor: `${
															isActive('/account') ? 'lightblue' : ''
														}`,
													}}
												>
													<div style={{ width: '2rem' }}>
														<FontAwesomeIcon
															icon={faWrench}
															size='xl'
															className={styles.icon}
														/>
													</div>
													<p>Account Settings</p>
												</div>
											</Link>
										</>
									)}

									{/* feedback */}
									<a href='mailto:feedback@scitrials.org?subject=Feedback on SciTrials.org'>
										<div className={styles.tab}>
											<div style={{ width: '2rem' }}>
												<FontAwesomeIcon
													icon={faComments}
													size='xl'
													className={styles.icon}
												/>
											</div>
											<p>Send Feedback</p>
										</div>
									</a>

									{/* login */}
									{session?.user ? (
										<>
											{session?.user?.role === 'admin' && (
												<a
													href='https://dashboard.scitrials.org'
													target='_blank'
													rel='noopener noreferrer'
												>
													<div className={styles.tab}>
														<div style={{ width: '2rem' }}>
															<FontAwesomeIcon
																icon={faPenToSquare}
																size='xl'
																className={styles.icon}
															/>
														</div>
														<p>Admin Dashboard</p>
													</div>
												</a>
											)}

											<hr />

											<div
												className={styles.tab}
												onClick={() => tabHandler(false, true)}
											>
												<div style={{ width: '2rem' }}>
													<FontAwesomeIcon
														icon={faArrowRightToBracket}
														size='xl'
														className={styles.icon}
													/>
												</div>
												<p>Log out</p>
											</div>
										</>
									) : (
										<Link href={'/auth'} onClick={() => tabHandler()}>
											<div className={styles.tab}>
												<div style={{ width: '2rem' }}>
													<FontAwesomeIcon
														icon={faArrowRightToBracket}
														size='xl'
														className={styles.icon}
													/>
												</div>
												<p>Login/Register</p>
											</div>
										</Link>
									)}
								</div>
							</Drawer.Body>
							<Drawer.CloseTrigger asChild display={'none'}>
								<CloseButton size='sm' />
							</Drawer.CloseTrigger>
						</Drawer.Content>
					</Drawer.Positioner>
				</Portal>
			</Drawer.Root>

			<NotificationModal
				isOpen={isOpen('notification-modal')}
				onClose={() => onClose('notification-modal')}
			/>
		</>
	);
};

export default MenuDrawer;
